import api from '@/lib/axios';

export interface EquipmentForSaleItem {
    id: string;
    equipmentTypeId: string;
    equipmentTypeName: string;
    brand?: string;
    serialNumber?: string;
    saleCondition: string; // A, B, C, or D
    conditionDescription: string; // Excellent, Good, Fair, Usable
    salePrice: number;
    listedForSaleAt: string;
    locationId: string;
    locationName: string;
    primaryImageUrl?: string;
}

export interface EquipmentForSaleResponse {
    items: EquipmentForSaleItem[];
    totalCount: number;
    page: number;
    pageSize: number;
}

export interface EquipmentSalePriceResponse {
    price: number;
}

export interface PurchaseEquipmentRequest {
    equipmentId: string;
}

export interface PurchaseEquipmentResponse {
    paymentIntentId: string;
    clientSecret: string;
    publishableKey?: string;
    amount: number;
}

/**
 * Get all equipment items available for sale at a location
 */
export const getItemsForSale = async (params: {
    locationId?: string;
    equipmentTypeId?: string;
    condition?: string;
    page?: number;
    pageSize?: number;
}): Promise<EquipmentForSaleResponse> => {
    const searchParams = new URLSearchParams();

    if (params.locationId) searchParams.append('locationId', params.locationId);
    if (params.equipmentTypeId) searchParams.append('equipmentTypeId', params.equipmentTypeId);
    if (params.condition) searchParams.append('condition', params.condition);
    if (params.page) searchParams.append('page', params.page.toString());
    if (params.pageSize) searchParams.append('pageSize', params.pageSize.toString());

    const { data } = await api.get<EquipmentForSaleResponse>(
        `/EquipmentSales/customer/for-sale?${searchParams.toString()}`
    );

    return data;
};

/**
 * Get the sale price for a specific equipment item
 */
export const getSalePrice = async (equipmentId: string): Promise<EquipmentSalePriceResponse> => {
    const { data } = await api.get<EquipmentSalePriceResponse>(
        `/EquipmentSales/customer/${equipmentId}/price`
    );

    return data;
};

/**
 * Initiate a purchase for an equipment item
 */
export const purchaseEquipment = async (equipmentId: string): Promise<PurchaseEquipmentResponse> => {
    const { data } = await api.post<PurchaseEquipmentResponse>(
        `/EquipmentSales/customer/${equipmentId}/purchase`,
        {}
    );

    return data;
};
